import React, { Fragment, useEffect, useRef, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link, useParams} from 'react-router-dom';

import api from '../api';
import config from '../config';
import validate from '../validate';

import {Wrap, Float, Title} from '../components/common';
import {BtnBorder} from '../components/buttons';
import {Form, FormControl, FormError} from '../components/form';
import {Helmet} from 'react-helmet';

const {siteName} = config;

export default () => {
  const history = useHistory();
  const {subject_number} = useParams();
  const [subject, setSubject] = useState(null);
  const [code, setCode] = useState([]);
  const [errors, setErrors] = useState({})
  const [panic, setPanic] = useState(null);
  const [first_submit, setFirstSubmit] = useState(true);
  const $btn = useRef();
  const inputs = useRef([]);
  const input_num = 6;

  useEffect(() => {
    if (sessionStorage.getItem('SIGN')) {
      history.push('/attend/' + subject_number);
      return;
    }

    for ( let i = 0; i < input_num; i++) {
      inputs.current.push(React.createRef());
    }

    api.get('/subjects/' + subject_number)
      .then((res) => {
        setSubject(res.data);
        api.post('/attend/sign').catch(error => {
          setPanic(error);
        });
      }).catch(error => {
        setPanic(error);
      })
  }, []);

  useEffect(() => {
    const data = {code: code.join('')};
    if ( ! first_submit ) {
      const errors = validate.attend_confirm(data);
      setErrors(errors);
    }
  }, [code]);

  const doSubmit = () => {
    const data = {code: code.join('')};
    const errors = validate.attend_confirm(data);

    if ( Object.keys(errors).length > 0) {
      setErrors(errors);
      setFirstSubmit(false);
      return false;
    }

    api.post('/attend/verify', {code: code.join('')})
      .then((res) => {
        sessionStorage.setItem('SIGN', res.data);
        history.push('/attend/'+subject_number);
      }).catch(error => {
        if ( error.code == 401 ) {
          setPanic(error);
        } else {
          setErrors({code: '確認用コードが正しくありません'});
        }
      });
  }

  const setNumber = (num, value) => {
    const c = [];
    if ( value.length == 1 ) {
      for ( let i = 0; i < input_num; i++ ) {
        c.push(i == num ? value : code[i] || '');
      }
      setCode(c);

      if ( num < input_num - 1 ) {
        inputs.current[num + 1].current.focus();
      } else {
        $btn.current.focus();
      }
    } else if ( value.length > 1 ) {
      const s = value.trim().split('');
      setCode(s);
      $btn.current.focus();
    }
  }
  const delBefore = (num, ev) => {
    if ( ev.which == 46 || ev.which == 8 ) {
      const c = code.slice();
      c[ev.target.value == '' ? num - 1 : num] = '';
      setCode(c);
      if ( num !== 0 ) {
        inputs.current[num - 1].current.focus();
      }
    }
  }
  const focusInput = (e) => {
      if (e) {
        ((e) => {
          setTimeout( () => {setFocus(e);});
        })(e);
      }
  }

  const setFocus = (e) => {
      if (e) {
          var targetTag = e.target;
          targetTag.focus();
          var num = targetTag.value.length;
          var bgn = 0;
          var end = num;
          if(typeof(targetTag.selectionStart) != "undefined"){
              targetTag.selectionStart = bgn;
              targetTag.selectionEnd = end;
          } else if(document.selection) {
              var range = targetTag.createTextRange();
              range.collapse();
              range.moveEnd( "character", bgn );
              range.moveStart( "character", end );
              range.select();
          }   
      }
  }
  const inputBox = () => {
    const list = [];
    for ( let i = 0; i < input_num; i++ ) {
      list.push(<input css={css`
        font-size: 24px;
        border: 1px solid #ccc;
        width: 14%;
        height: 60px;
        text-align: center;
        ${errors.code && `border: 1px solid #f00;`}
      `}
        type="tel"
        autoFocus={i == 0}
        key={i}
        pattern="\d*"
        value={code[i]}
        onKeyUp={(ev) => delBefore(i, ev)}
        onChange={(ev) => setNumber(i, ev.target.value)}
        onFocus={(ev) => focusInput(ev)}
        ref={inputs.current[i]}/>)
    }
    return (
      <div css={css`
        display: flex;
        justify-content: space-between;
        max-width: 338px;
        width: 100%;
      `}>
        {list}
      </div>
    )
  }

  if ( panic ) {
    throw panic;
  }
  return (
    <Wrap>
      <Helmet>
        <title>本人確認 | {siteName}</title>
      </Helmet>
      <Float>
      {subject && <div css={css`display: flex; flex-direction: column; align-items: center;`}>
        <div css={css`margin-bottom: 2rem`}>
          <Title name={subject.title}/>
        </div>
        <p>本人確認コードをメールアドレスに送信しました</p>
        <div css={css`margin-top: 2rem`}>
          {inputBox(input_num)}
        </div>
        {errors.code && <FormError text={errors.code}/>}
        <div css={css`display: flex; justify-content: center; margin-top: 30px;`}>
          {BtnBorder({ref: $btn, name: "認証コードを送信",action: () => doSubmit()})}
        </div>
        <div css={css`
          text-align: center;
          margin-top: 40px;
        `}>
          <Link to={`/`} css={css`color: #666; &:hover { color: black; }`}>ホームに戻る</Link>
        </div>
      </div>}
      </Float>
    </Wrap>
  );
};
